import css from 'styled-jsx/css';

import {styles} from '@zoefin/design-system';

const {color, typography} = styles;

export const COMP_NAME = 'registration-view';

export const globalStyles = css.global`
  .registration-view {
    &__otp-close-btn {
      border: none;
      background-color: transparent;
      position: absolute;
      top: 32px;
      right: 32px;
      cursor: pointer;
      img {
        width: 20px;
        height: 20px;
      }
    }
    &__otp-access {
      .otp-access__container--code {
        padding-top: 36px;
      }
      .otp-access__bottom {
        position: relative;
        padding: 32px 0 0 0;
        z-index: 0;
        &::before {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          height: calc(100% + 32px);
          width: calc(100% + 64px);
          transform: translate(-32px, 32px);
          border-radius: 0 0 16px 16px;
          z-index: -1;
          background: ${color.light};
        }
      }
    }
    &__input {
      margin-bottom: 32px;
    }
  }
`;

const registrationStyles = css`
  .${COMP_NAME} {
    display: flex;
    flex-direction: column;

    &__left {
      text-align: center;
      line-height: 19px;
      padding-top: 62px;

      &_confeti {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 150px;
        transform: translateY(-60%);
      }

      &_avatar1,
      &_avatar2,
      &_avatar3 {
        position: absolute;
        top: 16px;
        left: 50%;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        overflow: hidden;
        transform: translateX(-30px);
        filter: blur(2px);
      }

      &_avatar1 {
        transform: translateX(-116px);
      }

      &_avatar3 {
        transform: translateX(56px);
      }

      &_title {
        width: 90%;
        margin: 16px auto;
        font-weight: ${typography.weight.medium};
        color: #18a57a;
      }

      &_subtitle {
        margin-bottom: 8px;
        color: ${color.dark};
      }

      &_sneakpeak {
        display: none;
        max-width: 397px;
      }
    }

    &__right {
      &_title {
        display: none;
      }

      &_fields {
        max-width: 320px;
        margin: 0 auto;
      }

      &_button {
        max-width: 343px;
        margin: 8px auto 0;
      }

      &_disclosures {
        color: ${color.mediumDark};
        max-width: 585px;
        font-size: ${typography.size.s1};
        line-height: 16px;
        text-align: center;

        a {
          color: ${color.mediumDark};
        }
      }
    }

    &__input {
      & > div:first-of-type {
        display: none;
      }
    }

    @media screen and (min-width: 1024px) {
      flex-wrap: wrap;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      height: 100%;
      flex-direction: row;
      background-color: #ffffff;

      &__left,
      &__right {
        flex: 1 0 0;
        background-color: #fbfbfd;
      }

      &__left {
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 450px;
        overflow: hidden;
        padding-top: 0;

        &_confeti {
          display: none;
        }

        &_avatar1,
        &_avatar2,
        &_avatar3 {
          display: none;
        }

        &_title {
          display: none;
        }

        &_subtitle {
          display: none;
        }

        &_sneakpeak {
          display: block;
          max-width: 397px;
        }
      }

      &__right {
        display: flex;
        flex-direction: column;
        justify-content: center;
        box-shadow: 0 0 16px rgba(29, 35, 58, 0.15);

        &_title {
          display: block;
          width: 90%;
          margin: 38px auto 10px;
          text-align: center;
          font-size: ${typography.size.m2};
          font-weight: ${typography.weight.medium};
          line-height: 28px;
          color: #18a57a;
        }

        &_fields {
          width: 400px;
        }

        &_button {
          max-width: 216px;
          margin: 16px auto 0;
        }

        &_disclosures {
          margin: auto;
          text-align: center;
          width: 365px;
        }
      }

      &__input {
        & > div:first-of-type {
          display: initial;
        }

        & > div:last-of-type {
          display: none;
        }
      }
    }
  }
`;

export default registrationStyles;
